import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import Spin from 'components/common/Spin';
import {
  GET_STUDENT_MILESTONES,
  GET_STUDENT_NOT_STARTED_MILESTONES,
} from 'graphql/student/milestones';
import Helmet from 'react-helmet';
import MilestoneCard from 'modules/student/timeline/components/MilestoneCard';
import TodoTasks from './TodoTasks';
import ReferralPopup from 'modules/referral/components/ReferralPopup';
import { GET_REFERRAL } from 'graphql/referral';
import { useQuery, useMutation, Query } from 'react-apollo';
import {
  UPSERT_REFERRAL_POPUP,
  GET_REFERRAL_POPUP_DATE,
} from 'graphql/referral-popup-date';
import { toUserTimezone } from 'utils';
import ReferralCard from 'modules/referral/components/ReferralCard';

const useStyles = makeStyles((theme) => ({
  root: {},
  alert: {
    'backgroundColor': '#000',
    'paddingRight': 24,
    'color': '#fff',
    [theme.breakpoints.down('sm')]: {
      'display': 'block',
      'padding': theme.spacing(3),
      '& .MuiAlert-message': {
        marginBottom: theme.spacing(3),
      },
      '& .MuiAlert-action': {
        paddingLeft: 0,
      },
    },
    '& .MuiAlert-icon': {
      marginLeft: -6,
    },
  },
}));

const UpcomingMilestones = ({ user, profile, userId }) => {
  return (
    <Query
      query={GET_STUDENT_NOT_STARTED_MILESTONES}
      variables={{ userId, limit: 1 }}
      fetchPolicy="cache-and-network"
    >
      {({ data }) => {
        if (!data) return <Spin spinning linear />;
        else if (!data.milestones.length) {
          return null;
        }

        return data.milestones.map((m) => (
          <MilestoneCard
            user={user}
            milestone={m}
            key={m.id}
            student={{
              ...user,
              ...profile,
            }}
          />
        ));
      }}
    </Query>
  );
};

const Todo = ({ userId }) => {
  const classes = useStyles();
  const user = useSelector((s) => s.user.user);
  const profile = useSelector((s) => s.student.profile);
  const [showAddInvite, setShowAddInvite] = useState(false);
  const [upsertReferralPopup] = useMutation(UPSERT_REFERRAL_POPUP);

  const { loading, error, data } = useQuery(GET_REFERRAL_POPUP_DATE, {
    variables: { type: 'referral' }, fetchPolicy: 'network-only',
  });

  const { data: referralData } = useQuery(GET_REFERRAL, {
    variables: { userId },
  });

  // useEffect(() => {
  //   // do some checking here to ensure data exist
  //   if (referralData) {
  //     // mutate data if you need to

  //     showPopupCondition();
  //   }
  //   if (data) {
  //     // console.log("this is jaggu data",data) //load data on componentMount
  //   }
  // }, [referralData, data]);

  // const showPopupCondition = () => {
  //   if (
  //     referralData === undefined ||
  //     referralData === '' ||
  //     data === undefined
  //   ) {
  //     return;
  //   } else {
  //     if (referralData.referrals.length === 0) {
  //       return;
  //     }
  //     if (data.show_popup_referral.length === 0) {
  //       // when no entry show popup
  //       setShowAddInvite(true);
  //     }

  //     // console.log("ispopup")
  //     isPopUp(); //check popup older than 30 days
  //   }
  // };

  //Props

  // const onCloseModal = () => {
  //   setShowAddInvite(false);
  //   updatePopupDate();
  //   window.analytics.track('Referral.InviteViaEmail.Cancelled');
  // };

  // const updatePopupDate = async () => {
  //   await upsertReferralPopup({
  //     variables: {
  //       user_id: user.id,
  //       type: 'referral',
  //       waitDays: 7,
  //       popup_date: moment.utc(),
  //     },
  //   });
  // };

  // check popup older than 30 days to show popUp

  // const isPopUp = () => {
  //   const resp = data;
  //   const currentDate = moment(toUserTimezone());
  //   const popupDate = resp?.show_popup_referral[0]?.popup_date;
  //   const waitDays = resp?.show_popup_referral[0]?.wait_days || 7;
  //   const diff = moment(popupDate).diff(currentDate, 'days');
  //   if (diff >= waitDays) {
  //     setShowAddInvite(true);
  //   }
  // };

  const expired =
    profile.is_trial &&
    moment(profile.trial_end_date).isBefore(new Date(), 'day');

  return (
    <div className={classes.root}>
      <Helmet title="TODO" />
      {profile.is_trial && (
        <Alert
          color={expired ? 'error' : 'info'}
          style={{ marginTop: 8, marginBottom: 24 }}
        >
          <AlertTitle>
            {expired ? 'Trial Expired.' : 'Thank you for trying out WeAdmit'}
          </AlertTitle>
          {expired ? (
            <Typography color="inherit" variant="body2">
              Your Trial Period Expired, Please contact WeAdmit Admin.
            </Typography>
          ) : (
            <Typography color="inherit" variant="body2">
              You're on WeAdmit{' '}
              <span style={{ textTransform: 'capitalize' }}>
                {profile.product_type}
              </span>{' '}
              Trial Plan.
              {profile.trial_end_date && (
                <>
                  Your trial will expire on{' '}
                  {moment(profile.trial_end_date).format('LL')}.
                </>
              )}
            </Typography>
          )}
        </Alert>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12} md={7}>
          <Query
            query={GET_STUDENT_MILESTONES}
            variables={{ userId, status: 'inprogress' }}
          >
            {({ data }) => {
              if (!data) return <Spin spinning linear />;
              else if (!data.milestones.length) {
                return (
                  <UpcomingMilestones
                    userId={userId}
                    user={user}
                    profile={profile}
                  />
                );
              }

              return data.milestones.map((m) => (
                <MilestoneCard
                  user={user}
                  milestone={m}
                  key={m.id}
                  student={{
                    ...user,
                    ...profile,
                  }}
                />
              ));
            }}
          </Query>
        </Grid>
        <Grid item xs={12} md={5}>
          <TodoTasks user={user} />
          {referralData?.referrals.length !== 0 && (
            <Box>
              <ReferralCard referral={referralData?.referrals[0]} />
            </Box>
          )}
        </Grid>
      </Grid>
      <ReferralPopup />
    </div>
  );
};

export default Todo;
